
export default {
  props: {
    tag: {
      type: String,
      default: "h1",
    },

    gsapOptions: {
      type: Object,
      required: false,
      default() {
        return {};
      },
    },

    title: String,
    text: String,
  },

  // SSR needed here, there is the only way
  mounted() {
    const options = {
      onScroll: true,
      duration: 0.6,
      ease: "power3.out",
      ...this.gsapOptions,
    };

    if (options.onScroll) {
      options.scrollTrigger = this.$refs.el;
    }

    import("@/utils/gsap").then(({ fade }) => {
      fade(this.$refs.el, options);
    });
  },
};
